import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { API_URL, scroll } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";

import HotelCsvForm from "../Admin/Hotel/HotelCsvForm";

import HotelCsvNav from "./HotelCsvNav";

import Nav from "./Nav";

const Hotelcsv = () => {
  const [details, setDetails] = useState({});
  const [notice, setNotice] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const { str } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.message) {
      setNotice({
        type: location.state.message.type,
        text: location.state.message.text,
      });
    }
  }, [location]);

  useEffect(() => {
    const init = async () => {
      const url = new URL(`${API_URL}/hotelcsvInit`);
      const params = {
        id: str ? str : "",
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          setDetails({ ...json });
          setAlert({});
          scroll();
        } else {
          setAlert({
            type: "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {alert.type === "working" ? (
        <Alert data={alert} />
      ) : (
        <>
          <div id="left-column">
            <Hdg section="Hotel Report & Changes Admin" />

            <HotelCsvNav selected="csv" str={str} />

            {notice.type && <Notice data={notice} />}

            <HotelCsvForm
              types={details.types}
              dates={details.dates}
              token={details.token}
            />

            <div className="spacer"></div>
          </div>

          <div id="right-column">
            <Nav fname={details.fname} />
          </div>
        </>
      )}
    </>
  );
};

export default Hotelcsv;
